import { render, staticRenderFns } from "./LoginInfo.vue?vue&type=template&id=620726dc&scoped=true&"
import script from "./LoginInfo.vue?vue&type=script&lang=js&"
export * from "./LoginInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620726dc",
  null
  
)

export default component.exports